module.exports = __webpack_public_path__ + "static/img-coding.d3b1e7d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-coding.jpg
// module id = 782
// module chunks = 115898287384546